import {
  CButton,
  CCard,
  CCol,
  CHeader,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CRow
} from '@coreui/react';
import React, { useContext, useEffect, useState } from 'react';
import { getAverageSummary, getSummary } from 'src/services/Summary/Summary';
import Moment from 'moment';
import { DateRangePicker } from 'react-date-range';
import { format, isWeekend } from 'date-fns';
import SummaryDownload from './Download/Summary';
import { useNavigate } from 'react-router-dom';
import { cil3d, cilArrowRight, cilDescription } from '@coreui/icons';
import CIcon from '@coreui/icons-react';
import ls from 'local-storage';
import formatter from 'src/reusables/formatter';
import { useWindowDimensions } from 'src/reusables/useWindowDimension';
import BoothPicker from 'src/components/BoothPicker';
import { AuthContext } from 'src/App';
import Authentication, { AUTH_KEY } from 'src/utils/auth/Authentication';

function Summary() {
  const navigate = useNavigate();
  const Auth = useContext(AuthContext);

  const [summaryData, setSummaryData] = useState([]);
  const [averageSummaryData, setAverageSummaryData] = useState([]);

  const [drModal, setDrModal] = useState(false);
  const [refetch, setRefetch] = useState(false);
  const { height, width, comparison } = useWindowDimensions();

  const endDay = Moment(new Date()).format('YYYY-MM-DD');
  const max = new Date(endDay);

  const [dateRange, setDateRange] = useState([
    {
      startDate: new Date(`${Moment(new Date()).startOf('month')}`),
      endDate: new Date()
    }
  ]);

  async function fetchSummary(dateFrom, dateTo, id) {
    const res = await getSummary(dateFrom, dateTo, id ?? '');
    setSummaryData(res.data);
  }
  // endDate: ls.get("dateRange") ? new Date(ls.get("dateRange").endDate) : new Date()}])

  async function fetchSummary(dateFrom, dateTo, id) {
    const res = await getSummary(dateFrom, dateTo, id);
    setSummaryData(res.data);
  }

  async function fetchAverageSummary(dateFrom, dateTo, id) {
    const res = await getAverageSummary(dateFrom, dateTo, id);
    setAverageSummaryData(res.data);
  }

  function toSQLDateFormat(date) {
    return Moment(new Date(date)).format('YYYY-MM-DD');
  }

  function handleDetailPerSales(id, name) {
    navigate(`/merchant-per-sales`, {
      state: { salesID: id, salesName: name }
    });
  }

  useEffect(() => {
    const newStartDay = formatter('SQLDate', dateRange[0].startDate);
    const newEndDay = formatter('SQLDate', dateRange[0].endDate);

    fetchSummary(newStartDay, newEndDay, ls.get('booth')?.id ?? '');
    fetchAverageSummary(newStartDay, newEndDay, ls.get('booth')?.id ?? '');
  }, [refetch, dateRange]);

  return (
    <>
      <CModal
        visible={drModal}
        style={{
          width: comparison < 1 ? '' : 'fit-content',
          overflowX: comparison < 1 ? 'scroll' : 'visible'
        }}
      >
        <CModalHeader
          style={{
            width: comparison < 1 ? `${(85 * 1) / comparison}vw` : ''
          }}
        >
          <CModalTitle>Date Range</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <CCol xs="12" lg="10">
            <DateRangePicker
              onChange={(item) => {
                setDateRange([item.range1]);
                ls.set('dateRange', item.range1);
              }}
              showSelectionPreview={true}
              moveRangeOnFirstSelection={false}
              months={1}
              maxDate={max}
              ranges={dateRange}
              direction="vertical"
              weekStartsOn={1}
              calendarFocus="backwards"
              preventSnapRefocus={true}
              rangeColors={['#4E5B97']}
            />
          </CCol>
        </CModalBody>
        <CModalFooter
          style={{
            width: comparison < 1 ? `${(85 * 1) / comparison}vw` : ''
          }}
        >
          <CButton style={{ backgroundColor: '#4E5B97', border: 'none' }} onClick={() => setDrModal(!drModal)}>
            Close
          </CButton>
          <CButton
            style={{ backgroundColor: '#4E5B97', border: 'none' }}
            onClick={() => {
              setRefetch(true);
              setDrModal(false);
            }}
          >
            OK
          </CButton>
        </CModalFooter>
      </CModal>
      <CCol xs="12 bg-light">
        <CRow>
          <CCol>
            <CButton
              className="ml-3 mb-3 btn btn-dark"
              style={{ backgroundColor: '#4E5B97', border: 'none' }}
              hover="true"
              onClick={() => {
                setDrModal(!drModal);
              }}
            >
              <div>
                {Moment(dateRange[0].startDate).format('ll')}
                {' - '}
                {Moment(dateRange[0].endDate).format('ll')}
              </div>
            </CButton>
          </CCol>
          <CCol>
            <BoothPicker />
          </CCol>
        </CRow>

        <CCard style={{ padding: '2vh 2vw' }}>
          <CRow>
            <CCol xs={6}>
              <p className="fs-3 fw-bold">SUMMARY</p>
            </CCol>
            <CCol xs={6} style={{ textAlign: 'right' }}>
              {Auth.isAllowed(Auth.role[AUTH_KEY.export_reports]) && (
                <SummaryDownload
                  dateFrom={formatter('SQLDate', dateRange[0].startDate)}
                  dateUntil={formatter('SQLDate', dateRange[0].endDate)}
                  summaryData={summaryData}
                />
              )}
            </CCol>
          </CRow>

          <CCol xs="12">
            <CRow>
              <CCol>Average Transaction Time</CCol>
              <CCol>{summaryData.avgTrxTime ?? 0} minutes</CCol>
            </CRow>
            <CRow>
              <CCol>Print Count</CCol>
              <CCol>{summaryData.print_count}</CCol>
            </CRow>
            <CRow>
              <CCol>Reprint Count</CCol>
              <CCol>{summaryData.reprint_count ?? 0}</CCol>
            </CRow>
            <CRow>
              <CCol>Happy Hour Count</CCol>
              <CCol>{summaryData.is_happy_hour ?? 0}</CCol>
            </CRow>
            <CRow>
              <CCol>Failed Upload Count</CCol>
              <CCol>{summaryData.failed_upload ?? 0}</CCol>
            </CRow>
            <CRow>
              <CCol>Timeout Count</CCol>
              <CCol>{summaryData.timeout_count ?? 0}</CCol>
            </CRow>
            <CRow>
              <CCol>Refund Count</CCol>
              <CCol>{summaryData.refundCount ?? 0}</CCol>
            </CRow>
            <CRow>
              <CCol>Gross Sales Transaction</CCol>
              <CCol>{formatter('currency', summaryData.total_transaction ?? 0)}</CCol>
            </CRow>
            <CRow>
              <CCol>Gross Sales Reprint</CCol>
              <CCol>{formatter('currency', summaryData.total_reprint ?? 0)}</CCol>
            </CRow>
            <CRow>
              <CCol>Gross Sales</CCol>
              <CCol>{formatter('currency', summaryData.gross_sales ?? 0)}</CCol>
            </CRow>
            <CRow>
              <CCol>Discount</CCol>
              <CCol>
                ({formatter('currency', summaryData.discount ?? 0)}) / {summaryData.voucher_count ?? 0} Vouchers
              </CCol>
            </CRow>
            <CRow>
              <CCol>Refund</CCol>
              <CCol>({formatter('currency', summaryData.refundAmount ?? 0)})</CCol>
            </CRow>
            <CRow>
              <CCol>Revenue</CCol>
              <CCol>
                <b> {formatter('currency', summaryData.revenue ?? 0)}</b>
              </CCol>
            </CRow>
            {ls.get('userDetail').org_id === 0 || ls.get('userDetail').org_id === '0' ? (
              <>
                <CRow>
                  <CCol>Total Xendit Charge</CCol>
                  <CCol>({formatter('currency', summaryData.charge_xendit ?? 0)})</CCol>
                </CRow>
                <CRow>
                  <CCol>Revenue After Xendit Charge</CCol>
                  <CCol>{formatter('currency', summaryData.revenue_after_xendit ?? 0)}</CCol>
                </CRow>
                <CRow>
                  <CCol>COGS</CCol>
                  <CCol>({formatter('currency', summaryData.cogs ?? 0)})</CCol>
                </CRow>
                <CRow>
                  <CCol>Gross Profit</CCol>
                  <CCol>{formatter('currency', summaryData.gross_profit ?? 0)}</CCol>
                </CRow>
                <CRow>
                  <CCol>Operational Expenses</CCol>
                  <CCol>({formatter('currency', summaryData.opex ?? 0)})</CCol>
                </CRow>
                <CRow>
                  <CCol>Net Profit</CCol>
                  <CCol>
                    <b>{formatter('currency', summaryData.net_profit ?? 0)}</b>
                  </CCol>
                </CRow>
              </>
            ) : (
              <></>
            )}
          </CCol>
        </CCard>

        <CCard style={{ padding: '2vh 2vw' }}>
          <CRow>
            <CCol xs={6}>
              <p className="fs-3 fw-bold"> DAILY AVERAGE SUMMARY </p>
            </CCol>
            <CCol xs={6} style={{ textAlign: 'right' }}>
              {Auth.isAllowed(Auth.role[AUTH_KEY.export_reports]) && (
                <SummaryDownload
                  dateFrom={formatter('SQLDate', dateRange[0].startDate)}
                  dateUntil={formatter('SQLDate', dateRange[0].endDate)}
                  summaryData={averageSummaryData}
                />
              )}
            </CCol>
          </CRow>

          <CCol xs="12">
            <CRow>
              <CCol>Average Transaction Time</CCol>
              <CCol>{averageSummaryData.avgTrxTime ?? 0} minutes</CCol>
            </CRow>
            <CRow>
              <CCol>Print Count</CCol>
              <CCol>{parseFloat(averageSummaryData.print_count).toFixed(2) ?? 0}</CCol>
            </CRow>
            <CRow>
              <CCol>Reprint Count</CCol>
              <CCol>{parseFloat(averageSummaryData.reprint_count).toFixed(2) ?? 0}</CCol>
            </CRow>
            <CRow>
              <CCol>Happy Hour Count</CCol>
              <CCol>
                {averageSummaryData.is_happy_hour ? parseFloat(averageSummaryData.is_happy_hour).toFixed(2) : 0}
              </CCol>
            </CRow>
            <CRow>
              <CCol>Failed Upload Count</CCol>
              <CCol>{parseFloat(averageSummaryData.failed_upload).toFixed(2) ?? 0}</CCol>
            </CRow>
            <CRow>
              <CCol>Timeout Count</CCol>
              <CCol>
                {averageSummaryData.timeout_count ? parseFloat(averageSummaryData.timeout_count).toFixed(2) : 0}
              </CCol>
            </CRow>
            <CRow>
              <CCol>Refund Count</CCol>
              <CCol>{parseFloat(averageSummaryData.refundCount).toFixed(2) ?? 0}</CCol>
            </CRow>
            <CRow>
              <CCol>Gross Sales Transaction</CCol>
              <CCol>{formatter('currency', averageSummaryData.total_transaction ?? 0)}</CCol>
            </CRow>
            <CRow>
              <CCol>Gross Sales Reprint</CCol>
              <CCol>{formatter('currency', averageSummaryData.total_reprint ?? 0)}</CCol>
            </CRow>
            <CRow>
              <CCol>Gross Sales</CCol>
              <CCol>{formatter('currency', averageSummaryData.gross_sales ?? 0)}</CCol>
            </CRow>
            <CRow>
              <CCol>Discount</CCol>
              <CCol>
                ({formatter('currency', averageSummaryData.discount ?? 0)}) /{' '}
                {parseFloat(averageSummaryData.voucher_count).toFixed(2) ?? 0} Vouchers
              </CCol>
            </CRow>
            <CRow>
              <CCol>Refund</CCol>
              <CCol>({formatter('currency', averageSummaryData.refundAmount ?? 0)})</CCol>
            </CRow>
            <CRow>
              <CCol>Revenue</CCol>
              <CCol>
                <b> {formatter('currency', averageSummaryData.revenue ?? 0)}</b>
              </CCol>
            </CRow>

            {ls.get('userDetail').org_id === 0 || ls.get('userDetail').org_id === '0' ? (
              <>
                <CRow>
                  <CCol>Total Xendit Charge</CCol>
                  <CCol>({formatter('currency', averageSummaryData.charge_xendit ?? 0)})</CCol>
                </CRow>
                <CRow>
                  <CCol>Revenue After Xendit Charge</CCol>
                  <CCol>{formatter('currency', averageSummaryData.revenue_after_xendit ?? 0)}</CCol>
                </CRow>
                <CRow>
                  <CCol>COGS</CCol>
                  <CCol>({formatter('currency', averageSummaryData.cogs ?? 0)})</CCol>
                </CRow>
                <CRow>
                  <CCol>Gross Profit</CCol>
                  <CCol>{formatter('currency', averageSummaryData.gross_profit ?? 0)}</CCol>
                </CRow>
                <CRow>
                  <CCol>Operational Expenses</CCol>
                  <CCol>({formatter('currency', averageSummaryData.opex ?? 0)})</CCol>
                </CRow>
                <CRow>
                  <CCol>Net Profit</CCol>
                  <CCol>
                    <b>{formatter('currency', averageSummaryData.net_profit ?? 0)}</b>
                  </CCol>
                </CRow>
              </>
            ) : (
              <></>
            )}
          </CCol>
        </CCard>
      </CCol>
    </>
  );
}

export default Summary;
